import React, { Component } from 'react'
import { connect } from 'react-redux'
import { mapCardBrandToIcon } from './credit-cards-list.component'
import { StyledCardInfo } from './styles/card-info.style'
import { SecurityCodeInput } from '../form-components/inputs.component'

class CardInfo extends Component {
	render() {
		const { creditCards } = this.props

		return (
			<StyledCardInfo>
				{creditCards
					.filter(creditCard => creditCard.main)
					.map((creditCard, i) => (
						<div className="card-number" key={i}>
							<div style={{ fontSize: '15px' }}>
								Número do cartão de crédito
							</div>
							<div>
								<div className="card-logo">
									{mapCardBrandToIcon(creditCard.brand)}
								</div>
								<p>**** **** **** {creditCard.lastFourDigits}</p>
							</div>
						</div>
					))}

				<SecurityCodeInput
					id="securityCode"
					className="security-code"
					label="Código de segurança"
					maxLength={4}
					{...this.props}
				/>
			</StyledCardInfo>
		)
	}
}

const mapStateToProps = ({ creditCards }) => creditCards

const connectedCardInfo = connect(mapStateToProps)(CardInfo)

export { connectedCardInfo as CardInfo }
